import { render, staticRenderFns } from "./symx.vue?vue&type=template&id=370f599a&"
import script from "./symx.vue?vue&type=script&lang=js&"
export * from "./symx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports